<template>
  <div>
    <div v-show="!showMapPanel" class="plan">
      <plan-title />
      <plan-control :planId=id :isFull=false />
      <course @openMap="openMap" />
      <plan-price />
      <plan-control :planId=id :isFull=true />
    </div>
    <div v-show="showMapPanel" class="relative z-10">
      <map-detail @closeMap="closeMap"/>
    </div>
  </div>
</template>

<script>
import Course from '../components/organisms/Course'
import PlanControl from '../components/organisms/PlanControl'
import PlanTitle from '../components/organisms/PlanTitle'
import PlanPrice from '../components/organisms/PlanPrice'
import MapDetail from "../components/molecules/MapDetail"
import Constants from '../constants'

export default {
  components: {
    PlanTitle,
    Course,
    PlanControl,
    PlanPrice,
    MapDetail
  },
  data () {
    return {
      id: this.$route.params.id,
      showMapPanel: false
    }
  },
  created () {
    this.$store.dispatch('loading/beginLoading')
    this.$store.dispatch('plans/fetchPlan', this.id)
      .then(() => {
        this.$store.dispatch('tickets/fetchAll')
          .finally(() => {
            this.$store.dispatch('loading/endLoading')
          })
      })
      .catch(() => {
        this.$store.dispatch('loading/endLoading')
        this.$alert({
          message: this.$t('tour_not_found_plan'),
          success: () => {
            const areaId = this.$store.getters['user/getAreaId']
            if (areaId == Constants.DEFAULT_AREA_ID){
              this.$router.push({ name: 'plansTop', params: { lang: this.$store.getters['user/getLang'] }})
            }else{
              this.$router.push({ name: 'plansTop', params: { lang: this.$store.getters['user/getLang'], areaId: areaId }})
            }
          }
        })
      })
  },
  methods: {
    openMap: function () {
      this.showMapPanel = true
    },
    closeMap: function () {
      this.showMapPanel = false
    }
  }
}
</script>
